export type HydrationLifecycle = "not_started" | "hydrating" | "hydrated" | "failed";

export type HydrationEvent = "start" | "complete" | "fail" | "reset";

export function transitionHydrationLifecycle(current: HydrationLifecycle, event: HydrationEvent): HydrationLifecycle {
  if (event === "reset") {
    return "not_started";
  }
  if (event === "start") {
    return current === "not_started" ? "hydrating" : current;
  }
  if (event === "complete") {
    return current === "hydrating" ? "hydrated" : current;
  }
  if (event === "fail") {
    return current === "hydrating" ? "failed" : current;
  }
  return current;
}

export function shouldApplyHydratedSnapshot(lifecycle: HydrationLifecycle, hasLiveMutation: boolean): boolean {
  return lifecycle === "hydrating" && !hasLiveMutation;
}
